<script>
    import I18n from '@js/modules/translations';
    import {activateOnKey} from '@js/modules/a11y';

    import {fetchTags} from '@js/actions/tagsActions';

    const {
        name,
        label = I18n.t('js.ride.model.tags'),
        defaultValue = []
    } = $props();

    let tags = $state(defaultValue.map((t) => typeof t === 'string' ? t : t.name));
    let inputValue = $state('');
    let suggestions = $state([]);
    let availableTags = $state([]);
    let isFocused = $state(false);

    const _fetchTags = () => {
        if (availableTags.length > 0) {
            return;
        }

        fetchTags()
            .then((response) => {
                if (response?.tags) {
                    availableTags = response.tags.map((t) => t.name);
                }
            });
    };

    const _updateSuggestions = () => {
        const query = inputValue.trim().toLowerCase();
        if (!query) {
            suggestions = [];
            return;
        }

        suggestions = availableTags
            .filter((t) => t.toLowerCase().includes(query) && !tags.includes(t));
    };

    const _addTag = (value) => {
        const tagName = (typeof value === 'string' ? value : inputValue).trim().replace(/,/g, '');
        if (tagName && !tags.includes(tagName)) {
            tags = [...tags, tagName];
        }
        inputValue = '';
        suggestions = [];
    };

    const _removeTag = (index) => {
        tags = tags.filter((_, i) => i !== index);
    };

    const _handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ',') {
            event.preventDefault();
            _addTag();
        }
    };

    const _handleInput = () => {
        _updateSuggestions();
    };

    const _handleFocus = () => {
        isFocused = true;
        _fetchTags();
    };

    const _handleBlur = () => {
        setTimeout(() => {
            isFocused = false;
            _addTag();
        }, 150);
    };

    const _handleSuggestionClick = (tagName) => {
        _addTag(tagName);
    };
</script>

<div class="mx-auto w-full md:w-4/5">
    <label class="text-sm rtl:text-right font-medium block text-gray-900 dark:text-gray-300 space-y-2">
        <span>{label}</span>

        <div class="relative">
            <div class="flex flex-wrap gap-2 items-center p-2 border border-gray-500 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700">
                {#each tags as tag, index (tag)}
                    <span class="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-primary-100 text-primary-900 text-xs font-medium dark:bg-primary-900 dark:text-primary-200">
                        {tag}
                        <button type="button"
                                class="inline-flex items-center justify-center w-4 h-4 rounded-full hover:bg-primary-200 dark:hover:bg-primary-800 cursor-pointer"
                                onclick={() => _removeTag(index)}>
                            &times;
                        </button>
                    </span>
                {/each}

                <input type="text"
                       class="flex-1 min-w-[120px] border-none outline-none bg-transparent text-gray-900 dark:text-white dark:placeholder-gray-400 sm:text-xs p-0 focus:ring-0"
                       placeholder={tags.length === 0 ? I18n.t('js.selector.no_results') : ''}
                       bind:value={inputValue}
                       onkeydown={_handleKeyDown}
                       oninput={_handleInput}
                       onfocus={_handleFocus}
                       onblur={_handleBlur}/>
            </div>

            {#if isFocused && suggestions.length > 0}
                <ul role="listbox"
                    class="absolute z-10 w-full mt-1 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg max-h-40 overflow-y-auto">
                    {#each suggestions as suggestion (suggestion)}
                        <li class="px-3 py-2 text-sm text-gray-700 dark:text-gray-200 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600"
                            role="option"
                            aria-selected="false"
                            tabindex="0"
                            onmousedown={() => _handleSuggestionClick(suggestion)}
                            onkeydown={activateOnKey(() => _handleSuggestionClick(suggestion))}>
                            {suggestion}
                        </li>
                    {/each}
                </ul>
            {/if}
        </div>
    </label>

    {#each tags as tag (tag)}
        <input type="hidden"
               name={`${name}[]`}
               value={tag}/>
    {/each}
</div>
